<div mat-dialog-title class="iframe-dialog-title">
    {{ 'CATALOG.MODULE-DETAIL.PROVENANCE.DIALOG' | translate }}
    <mat-icon> account_tree </mat-icon>
</div>

<iframe [src]="iframeUrl" width="100%" height="100%" frameborder="0"></iframe>
